import React from 'react'

import { func, oneOf, string } from 'prop-types'

import AuthStep from './Components/AuthStep/AuthStep'
import CodeStep from './Components/CodeStep/CodeStep'
import SuccessStep from './Components/SuccessStep/SuccessStep'
import { MODE, STEP } from './constants'
import useSignIn from './Hooks/useSignIn'

// The full email-OTP auth flow (auth -> code -> success) without any modal
// chrome. AuthModal wraps it for the navigation popup; /users/login and
// /users/registration render it inline when new_top_navigation is enabled.
// `onSwitchMode` replaces the flow's internal login/signup toggle - the tabbed
// login page passes a tab switch instead, so the footer link and the tab
// header stay in sync.
function AuthFlow({
  mode: initialMode = MODE.SIGNUP,
  initialStep = STEP.AUTH,
  locale = 'en',
  onSwitchMode = null,
}) {
  const {
    mode,
    step,
    email,
    optIn,
    digits,
    hasCodeError,
    resendSecondsLeft,
    ariaLabel,
    setOptIn,
    handleEmailChange,
    requestCode,
    handleSwitchMode,
    handleDigitsChange,
    handleResend,
    handleChangeEmail,
    handleSocial,
  } = useSignIn({ initialMode, initialStep, locale })

  return (
    <div className="auth-modal__body" aria-label={ariaLabel}>
      <div className="auth-modal__main">
        {step === STEP.AUTH && (
          <AuthStep
            mode={mode}
            email={email}
            optIn={optIn}
            locale={locale}
            onEmailChange={handleEmailChange}
            onOptInChange={setOptIn}
            onSubmit={requestCode}
            onSocial={handleSocial}
            onSwitchMode={onSwitchMode || handleSwitchMode}
          />
        )}
        {step === STEP.CODE && (
          <CodeStep
            email={email}
            digits={digits}
            hasError={hasCodeError}
            resendSecondsLeft={resendSecondsLeft}
            locale={locale}
            onDigitsChange={handleDigitsChange}
            onResend={handleResend}
            onChangeEmail={handleChangeEmail}
          />
        )}
        {step === STEP.SUCCESS && <SuccessStep mode={mode} email={email} locale={locale} />}
      </div>
    </div>
  )
}

AuthFlow.propTypes = {
  mode: oneOf([MODE.SIGNUP, MODE.LOGIN]),
  initialStep: oneOf([STEP.AUTH, STEP.CODE, STEP.SUCCESS]),
  locale: string,
  onSwitchMode: func,
}

export default AuthFlow
